// translations by sections
import NAVIGATION_EN from './navigation/navigation.en.json'
import NAVIGATION_UA from './navigation/navigation.ua.json'
import HERO_EN from './hero/hero.en.json'
import HERO_UA from './hero/hero.ua.json'
import FEATURES_EN from './features/features.en.json'
import FEATURES_UA from './features/features.ua.json'
import OUR_PROJECTS_EN from './our-projects/our-projects.en.json'
import OUR_PROJECTS_UA from './our-projects/our-projects.ua.json'
import CONTACT_US_EN from './contact-us/contact-us.en.json'
import CONTACT_US_UA from './contact-us/contact-us.ua.json'
import ABOUT_US_EN from './about-us/about-us.en.json'
import ABOUT_US_UA from './about-us/about-us.ua.json'
import ABOUT_US_SECTION_EN from './about-us-section/about-us-section.en.json'
import ABOUT_US_SECTION_UA from './about-us-section/about-us-section.ua.json'

export const EN = {
  ...NAVIGATION_EN,
  ...HERO_EN,
  ...FEATURES_EN,
  ...OUR_PROJECTS_EN,
  ...CONTACT_US_EN,
  ...ABOUT_US_EN,
  ...ABOUT_US_SECTION_EN
}

export const UA = {
  ...NAVIGATION_UA,
  ...HERO_UA,
  ...FEATURES_UA,
  ...OUR_PROJECTS_UA,
  ...CONTACT_US_UA,
  ...ABOUT_US_UA,
  ...ABOUT_US_SECTION_UA
}
